<template>
    <div v-if="advancedData != null">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>包含:</span>
                <span class="ml10" v-if="!advancedData.resultFilter.lowCostFlag && advancedData.viewData.showSingle">单{{advancedData.assetCount.singleCount}}个</span>
                <span class="ml5" v-if="advancedData.viewData.showBatch">批{{advancedData.assetCount.batchCount}}个</span>
                <i class="el-icon-delete fr" style="color:#20A0FF; font-size: 16px;" @click="hendleClearAdvanced"></i>
            </div>
            <div class="simple-form">
                <div class="form-group top">
                    <div class="form-label">
                        <label>管理方式：</label>
                    </div>
                    <div class="form-value">
                        <div v-if="advancedData.viewData.showBatchLow && advancedData.resultFilter.includeBatch && (advancedData.resultFilter.lowCostFlag == null || advancedData.resultFilter.lowCostFlag == true)">
                            <span>耗材管理</span>
                        </div>
                        <div v-else>
                            <span v-if="advancedData.viewData.showSingle && advancedData.resultFilter.includeSingle">单品式管理</span>
                            <span v-if="advancedData.viewData.showBatch && advancedData.resultFilter.includeBatch">
                            <span v-if="advancedData.viewData.showBatchComn && advancedData.resultFilter.includeBatch && (advancedData.resultFilter.lowCostFlag == null || advancedData.resultFilter.lowCostFlag == false)">批量管理</span>
                        </span>
                        </div>
                    </div>
                </div>
                <div class="form-group top" v-if="advancedData.viewData.showWarehouse && advancedData.resultFilter.warehouseIds.length > 0">
                    <div class="form-label">
                        <label>所属仓库：</label>
                    </div>
                    <div class="form-value">
                        <span v-for="item in advancedData.viewData.dbOptions.warehouseList">
                            <span class="ml5" v-if="advancedData.resultFilter.warehouseIds.indexOf(item.id) > -1">{{item.name}}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group top" v-if="advancedData.viewData.showDepart && advancedData.resultFilter.departIds.length > 0">
                    <div class="form-label">
                        <label>责任部门：</label>
                    </div>
                    <div class="form-value">
                        <span v-for="item in advancedData.viewData.dbOptions.departList">
                            <span class="ml5" v-if="advancedData.resultFilter.departIds.indexOf(item.id) > -1">{{item.name}}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group top" v-if="advancedData.viewData.showCat && advancedData.resultFilter.catIds.length > 0">
                    <div class="form-label">
                        <label>分类：</label>
                    </div>
                    <div class="form-value">
                        <span v-for="item in advancedData.viewData.dbOptions.catList">
                            <span class="ml5" v-if="advancedData.resultFilter.catIds.indexOf(item.id) > -1">{{item.name}}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group top" v-if="advancedData.viewData.showGroup && advancedData.resultFilter.devcGroupIds.length > 0">
                    <div class="form-label">
                        <label>分类分组：</label>
                    </div>
                    <div class="form-value">
                        <span v-for="item in advancedData.viewData.dbOptions.groupList">
                            <span class="ml5" v-if="advancedData.resultFilter.devcGroupIds.indexOf(item.id) > -1">{{item.name}}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group top" v-if="advancedData.viewData.showKind && advancedData.resultFilter.kindIds.length > 0">
                    <div class="form-label">
                        <label>财务类别：</label>
                    </div>
                    <div class="form-value">
                        <span v-for="item in advancedData.viewData.dbOptions.kindList">
                            <span class="ml5" v-if="advancedData.resultFilter.kindIds.indexOf(item.id) > -1">{{item.name}}</span>
                        </span>
                    </div>
                </div>
                <div class="form-group top" v-if="advancedData.viewData.showAcctEnterWay && advancedData.resultFilter.acctEnterWays.length > 0">
                    <div class="form-label">
                        <label>入账方式：</label>
                    </div>
                    <div class="form-value">
                        <span v-for="item in advancedData.viewData.dbOptions.acctEnterWayList">
                            <span class="ml5" v-if="advancedData.resultFilter.acctEnterWays.indexOf(item.value) > -1">{{item.text}}</span>
                        </span>
                    </div>
                </div>
            </div>
        </el-card>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    export default {
        name: 'swb-asset-advanced-view',
        desc: '资产快捷选择显示',
        props: {
            advancedData: {
                type: Object,
                value: null
            },
            clearAdvanced: {
                type: Function
            }
        },
        data: function () {
            return {}
        },
        created: function () {
        },
        methods: {
            hendleClearAdvanced(){
                this.clearAdvanced.call(parent);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/asset/AssetAdvancedView.vue